/**
 * @generated SignedSource<<2cc3687d598dfcd55e2d23fa8efa8bd9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSkuThumbnails_ProductSkuImageConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly urlThumbnail: string;
    };
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"ShowSkuImagesGalleryButton_ProductSkuImageConnection">;
  readonly " $fragmentType": "ProductSkuThumbnails_ProductSkuImageConnection";
};
export type ProductSkuThumbnails_ProductSkuImageConnection$key = {
  readonly " $data"?: ProductSkuThumbnails_ProductSkuImageConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuThumbnails_ProductSkuImageConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSkuThumbnails_ProductSkuImageConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuImageEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuImage",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": "urlThumbnail",
              "args": [
                {
                  "kind": "Literal",
                  "name": "size",
                  "value": 420
                }
              ],
              "kind": "ScalarField",
              "name": "url",
              "storageKey": "url(size:420)"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShowSkuImagesGalleryButton_ProductSkuImageConnection"
    }
  ],
  "type": "ProductSkuImageConnection",
  "abstractKey": null
};

(node as any).hash = "bd52b129c83be49dd92938cb06506266";

export default node;
